import { ApplicationStatus } from "shared/types";

export const getInviteApplicationDisabledToolTip = (
  applicationStatus?: ApplicationStatus
) => {
  if (!applicationStatus) return undefined;

  if (
    [
      ApplicationStatus.Approved,
      ApplicationStatus.Rejected,
      ApplicationStatus.ConditionalApproved,
      ApplicationStatus.Canceled,
      ApplicationStatus.Merged
    ].includes(applicationStatus)
  )
    return "You can't invite applicants once the decisions have been made";

  if (applicationStatus === ApplicationStatus.OnHold)
    return "To invite applicants, resume application first";
};
